import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Initials, ProfileImage } from 'atoms';
import { getInitials } from 'utils/getInitials';
import { GenericWrapper, Mr2 } from 'wrappers';
import { AssignmentDate, Name } from './atoms';
import { format } from 'date-fns';
import { textEllipsis } from 'utils/ellipsis';

const template = styled.div`
   ${({ theme }) => css`
    margin-right: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${theme?.colour?.secondary};
    &:hover {
      color: ${theme?.colour?.primary} !important;
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: wrap(Initials, Mr2),
      name: 'Initials',
      renderIf: ({ image }) => !image,
      displayValue: ({ name }) => getInitials(name),
      displayState: ({ }) => ({ size: 30 })
    },
    {
      component: wrap(ProfileImage, Mr2),
      name: 'Initials',
      renderIf: ({ image }) => !!image,
      displayValue: ({ image }) => image,
      displayState: ({ }) => ({ size: 30, noBorder: true })
    },
    {
      wrapper: GenericWrapper,
      name: 'Name',
      atoms: [
        {
          component: Name,
          name: 'Name',
          displayValue: ({ name, maxLength }) => maxLength ? textEllipsis(name, maxLength) : name
        },
        {
          component: AssignmentDate,
          name: 'AssignmentDate',
          renderIf: ({ date }) => !!date,
          displayValue: ({ date }) => `since ${format(date, 'MM/dd hh:mm a')}`
        },
      ]
    }
  ],
})